import React, { Fragment, Component } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { withRouter} from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import _ from 'lodash';
import queryString from 'query-string';
import {
  IconButton, Dialog, DialogTitle, DialogContent,
  Button,
  Fade,
  DialogActions,
  Grid,
  Stepper,
  Step,
  StepLabel 
} from "@material-ui/core";
import styled from "styled-components";
import CloseIcon from "@material-ui/icons/Close";

import PrimaryButton from 'components/Global/Buttons/PrimaryButton';
import SecondaryButton from 'components/Global/Buttons/SecondaryButton';

import LoanStep from './Step';

const Spacer = styled.div`
  flex-grow:1;
`
const SelectedItemsNotification = styled.div`
  && {
    font-size:17px;  
    padding-left:20px;
    margin:0;
  }
`
const Description = styled.div`
  color: rgba(0, 0, 0, 0.537);
  padding-bottom:20px;
`;

const Error = styled.div`
  color:#ff0000;
  font-size:17px;
  padding-left:8px;
`

const StyledDialogActions = styled(DialogActions)`
  && {
    justify-content: flex-end;
  }
  `
  const StepperWrapper = styled.div`
  width: 400px;
  margin: 0 auto;
`;
const ButtonBar = styled.div`
  margin-right:4px;
`

const styles = {
  active: {
    color: "#2196f3 !important"
  },
  completed: {
    color: "#2196f3 !important"
  }
};
class CombineQuotesModal extends Component {
  state = {
    activeStep: 0,
    shouldShowError:false,
    errorMessage: '',
    selectedSeniorLoanIds: [],
    selectedMezzLoanIds: []
  }
  close = () => {
    this.setState({
      selectedSeniorLoanIds: [],
      selectedMezzLoanIds: [],
      activeStep: 0
    })
    this.props.onClose();
  }
  prevStep = () => {
    this.setState({
      activeStep: 0
    })
  }
  nextStep = () => {
    this.setState({
      activeStep: 1,      
    })
  }
  showMaxQuotesSelectedError = () => {
    this.setState({
      shouldShowError:true,
      errorMessage: 'You must choose only one senior and one subordinate quote.'
    })
  }
  getSelectedSeniorCount = () => {
    return this.state.selectedSeniorLoanIds.length;
  }
  getSelectedMezzCount = () => {
    return this.state.selectedMezzLoanIds.length;
  }
  select = (fieldName, selectedLoanIdsCopy, id) => {
    selectedLoanIdsCopy.push(id);
    this.setState({
      shouldShowError:false,
      [fieldName]:selectedLoanIdsCopy
    })
  }
  deselect = (fieldName,selectedLoanIdsCopy, index) => {
    selectedLoanIdsCopy.splice(index,1);
    this.setState({
      shouldShowError:false,
      [fieldName]:selectedLoanIdsCopy
    })
  }
  onToggleSenior = (id) => {
    this.onToggle('selectedSeniorLoanIds', id);
  }
  onToggleMezz = (id) => {
    this.onToggle('selectedMezzLoanIds', id);
  }

  onToggle = (fieldName, id) => {
    const selectedLoanIds = this.state[fieldName];    
    const selectedLoanIdsCopy = [...selectedLoanIds];
    let index = _.findIndex(selectedLoanIds, x => x === id );
    if(index === -1 && selectedLoanIdsCopy.length > 0)
      this.showMaxQuotesSelectedError();
    else if(index === -1)
      this.select(fieldName, selectedLoanIdsCopy,id);
    else 
      this.deselect(fieldName, selectedLoanIdsCopy,index);
   
  }

  goToCombine = () => {
    const{selectedSeniorLoanIds, selectedMezzLoanIds} = this.state;    
    const {dealId} = this.props;
    const selectedIds = _.concat(selectedSeniorLoanIds,selectedMezzLoanIds);

    let query = queryString.stringify(
      {
        loanId: selectedIds,
        methodName: "combine",
        useAggregateExisting: this.props.isCompareAndCombine,
      },
      {
        arrayFormat: 'bracket'
      });
    this.props.history.push(`/pipeline/deal/${dealId}/quote-comparison?${query}`);
  }

  renderCashflowsButton = () => {
    return null; //decided we dont want to show this in the modal, but leaving method in case they change their mind
    if(this.state.selectedSeniorLoanIds.length === 0 ) return null;
    if(this.state.selectedMezzLoanIds.length === 0 ) return null;
    let loanId1 = this.state.selectedSeniorLoanIds[0];
    let loanId2 = this.state.selectedMezzLoanIds[0];
    let url = `/portfolio/funds/free/deals/${this.props.dealId}/cashflowsPage?showActiveLoans=true&loanId=${loanId1}&loanId2=${loanId2}&showQuotes=true`;
    return <SecondaryButton onClick={()=>this.props.history.push(url)}>Cashflows</SecondaryButton>
  }
  
  render() {
    
    const { shouldShowError,errorMessage,activeStep, selectedSeniorLoanIds, selectedMezzLoanIds} = this.state;
    const { isOpen, maxCount, seniorLoans, mezzLoans,classes } = this.props;        
    if(!seniorLoans || !mezzLoans)
      return null;
    const stepIconProps = {
      classes: {
        active: classes.active,
        completed: classes.completed
      }
    };
    return (
      <Fragment>
        <Dialog open={isOpen} onClose={this.close} maxWidth="lg">
          <DialogContent style={{width:"1100px"}}>
          <Grid
            container
            direction="row"
            alignItems="center"
            justify="space-between"
          >
            <DialogTitle>Combine Quotes</DialogTitle>
            <IconButton style={{ marginRight: 16 }} onClick={this.close}>
              <CloseIcon style={{ fontSize: 36 }} />
            </IconButton>
          </Grid>          
          <DialogContent >
            <Stepper activeStep={activeStep} alternativeLabel>
              <Step key="senior">
                <StepLabel StepIconProps={stepIconProps}>
                  Choose Senior Quote
                </StepLabel>
              </Step>
              <Step key="mezz">
                <StepLabel StepIconProps={stepIconProps}>
                  Choose Subordinate Quote
                </StepLabel>
              </Step>
            </Stepper>
            {activeStep === 0 && <Description>Choose a senior quote:</Description>}
            {activeStep === 1 && <Description>Choose a subordinate quote:</Description>}
            {activeStep === 0 && <LoanStep loans={seniorLoans} selectedLoanIds={selectedSeniorLoanIds} onToggle={this.onToggleSenior}/>}
            {activeStep === 1 && <LoanStep  loans={mezzLoans} selectedLoanIds={selectedMezzLoanIds} onToggle={this.onToggleMezz}/>}
          </DialogContent>
          <StyledDialogActions>

            {activeStep === 0 && 
              <SelectedItemsNotification>{this.getSelectedSeniorCount()}/{1} Selected</SelectedItemsNotification>
            }
            {activeStep === 1 && 
              <SelectedItemsNotification>{this.getSelectedMezzCount()}/{1} Selected</SelectedItemsNotification>
            }
            {shouldShowError &&
            <Fade in={shouldShowError}>
              <Error>{errorMessage}</Error>
            </Fade>
            }
            <Spacer></Spacer>            
            {activeStep === 0 &&
              <ButtonBar>
                <SecondaryButton onClick={this.close}>CANCEL</SecondaryButton>
                <PrimaryButton disabled={_.isEmpty(this.state.selectedSeniorLoanIds)} onClick={this.nextStep}>NEXT</PrimaryButton>
              </ButtonBar>
            }
            {
              activeStep === 1 &&
              <ButtonBar>
                {this.renderCashflowsButton()}
                <SecondaryButton onClick={this.close}>CANCEL</SecondaryButton>
                <SecondaryButton onClick={this.prevStep}>BACK</SecondaryButton>
                <PrimaryButton disabled={_.isEmpty(this.state.selectedMezzLoanIds)} onClick={this.goToCombine}>GO TO COMBINE</PrimaryButton>
              </ButtonBar>
            }
          </StyledDialogActions>
          </DialogContent>
        </Dialog>
      </Fragment>
    )
  }
}


export default compose(    
  withStyles(styles),
  withRouter
)(CombineQuotesModal);


